import axios from '../api'

const getPriceList = params => {
  return axios({
    url: '/eos/coupon/orderManager/getConfigCouponByProductId',
    params
  })
}

const getMessageList = params => {
  return axios({
    url: '/eos/coupon/orderManager/getSmsTemplate',
    params
  })
}

const getCouponDocList = params => {
  return axios({
    url: '/eos/coupon/orderManager/getCouponTemplate',
    params
  })
}

const getAmount = params => {
  return axios({
    url: '/eos/coupon/orderManager/getOrderAmount',
    params
  })
}

const purchaseCoupon = params => {
  return axios({
    url: '/eos/coupon/orderManager/saveOrUpdateOrder',
    method: 'post',
    data: params
  })
}

const getOrderInfoForEdit = params => {
  return axios({
    url: '/eos/coupon/orderManager/getOrderInfo',
    params
  })
}

const getOrderInfoForCopy = params => {
  return axios({
    url: '/eos/coupon/orderManager/getOrderInfoForCopy',
    params
  })
}

export default {
  getPriceList,
  getMessageList,
  getCouponDocList,
  getAmount,
  purchaseCoupon,
  getOrderInfoForEdit,
  getOrderInfoForCopy
}
